export default "__VITE_ASSET__8ac3be2a__"